export const BOARD_LIKE_TYPE = 1;
export const COMMENT_LIKE_TYPE = 2;
export const COMMENT_PUBLIC = 1;

export const EVENT_SOURCE_WEB_SOCKET = "web_socket";
export const EVENT_SOURCE_API = "api";

export const INIT_DATA = "INIT_DATA";
export const UPDATE_SHOW_REPORT_RESULT_PAGE = "UPDATE_SHOW_REPORT_RESULT_PAGE";
export const UPDATE_SHOW_PENDING_APPROVAL_COMMENT_PAGE = "UPDATE_SHOW_PENDING_APPROVAL_COMMENT_PAGE";
export const FETCH_COMMENTS = "FETCH_COMMENTS";
export const FETCH_REPLY_COMMENTS = "FETCH_REPLY_COMMENTS";
export const ADD_COMMENT = "ADD_COMMENT";
export const ADD_REPLY_COMMENT = "ADD_REPLY_COMMENT";
export const EDIT_COMMENT = "EDIT_COMMENT";
export const EDIT_REPLY_COMMENT = "EDIT_REPLY_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const DELETE_REPLY_COMMENT = "DELETE_REPLY_COMMENT";
export const REPORT_BOARD = "REPORT_BOARD";
export const REPORT_COMMENT = "REPORT_COMMENT";
export const REPORT_REPLY_COMMENT = "REPORT_REPLY_COMMENT";
export const UPDATE_PINNED_COMMENT_STATUS = "UPDATE_PINNED_COMMENT_STATUS";
export const UPDATE_LIKED_COMMENT_STATUS = "UPDATE_LIKED_COMMENT_STATUS";
export const UPDATE_NEW_NICKNAME_AVATAR = "UPDATE_NEW_NICKNAME_AVATAR";
export const UPDATE_LIKED_BOARD_STATUS = "UPDATE_LIKED_BOARD_STATUS";
export const UPDATE_SNACKBAR = "UPDATE_SNACKBAR";

export const FORUM_APPROVAL_SETTING = {
  APPROVAL_ALL: 0,
  APPROVAL_ONLY_BOARD: 1,
  WITHOUT_APPROVAL: 2,
};
